import CommonConstants from '../constants/CommonConstants';
// import Immutable from 'immutable';

const initialState = {
  result: {},
  userData: {},
  error: null
};

function AccountReducer(state = initialState, action) {
  switch (action.type) {
    case CommonConstants.POST_STRIPE_CHECKOUT_SESSION_SUCCESS:
      return Object.assign({}, state, {
        postStripeCheckoutSession: action.response,
        error: null
      });

    case CommonConstants.POST_STRIPE_CHECKOUT_SESSION_ERROR:
      return Object.assign({}, state, {
        postStripeCheckoutSession: {},
        error: action.error
      });

    case CommonConstants.GET_STRIPE_CHECKOUT_SESSION_SUCCESS:
      return Object.assign({}, state, {
        stripeCheckoutSession: action.response,
        error: null
      });

    case CommonConstants.GET_STRIPE_CHECKOUT_SESSION_ERROR:
      return Object.assign({}, state, {
        stripeCheckoutSession: {},
        error: action.error
      });

    case CommonConstants.GET_STRIPE_CUSTOMER_SUCCESS:
      return Object.assign({}, state, {
        stripeCustomer: action.response.customer,
        stripePaymentMethod: action.response.paymentMethod,
        error: null
      });

    case CommonConstants.GET_STRIPE_CUSTOMER_ERROR:
      return Object.assign({}, state, {
        stripeCustomer: {},
        stripePaymentMethod: {},
        error: action.error
      });

    case CommonConstants.GET_USER_DETAILS_SUCCESS:
      return Object.assign({}, state, {
        userData: action.response,
        error: null
      });

    case CommonConstants.GET_USER_DETAILS_ERROR:
      return Object.assign({}, state, {
        userData: {},
        error: action.error
      });

    case CommonConstants.UPDATE_USER_DATA_SUCCESS:
      Object.entries(action.response).forEach(item => {
        let key = item[0];
        state.userData[key] = item[1];
      });

      return Object.assign({}, state, {
        userData: state.userData,
        error: null
      });

    case CommonConstants.UPDATE_USER_DATA_ERROR:
      return Object.assign({}, state, {
        userData: state.userData,
        error: action.error
      });

    default:
      return state;
  }
}

export default AccountReducer;



// WEBPACK FOOTER //
// ./reducers/AccountReducer.js